import {
  NO_REACTION,
  getColor,
  anyReactionsFromQueriesForReagent,
  findReagentPresentColorIds
} from "./megamix";

export const isQueryEmpty = query => {
  return (
    query == null ||
    query.reagentId == null ||
    query.colorIds == null ||
    query.colorIds.length === 0
  );
};

export const nullQuery = { reagentId: null, colorIds: [] };

export const queryHexColors = query => {
  if (query.colorIds === NO_REACTION) {
    return ["#bfbfbf"];
  } else {
    return query.colorIds.map(colorId => getColor(colorId).hex);
  }
};

export const searchThrough = (objs, match) => (
  objs.find(r => (
    Object.entries(match).map(([key, val]) => (
      r[key] === val
    ))
    .reduce((acc, elem) => (acc && elem), true)
  ))
);

const reagentPresentColorIds = findReagentPresentColorIds(true);
const isSimpleQuery = true;
export const isButtonDisabled = (colorId, query, queries, currentSubstanceIds) => {

  // Query not ready yet
  if (query.reagentId == null) {
    return true; // Disable if the reagent is not selected
  }

  // NO_REACTION is selected, so color buttons do not work here, disable
  if (query.colorIds === NO_REACTION) {
    return true;
  }

  // Color is selected, so don't disable
  if (query.colorIds.includes(colorId)) {
    return false;
  }

  // Check if no data
  const noData =
    query.reagentId != null &&
    !reagentPresentColorIds[query.reagentId].includes(colorId);

  if (noData) {
    // Treat no data as no reaction
    return true;
  }

  // Clone query and add this color
  let queryWithThisButton = { ...query };
  queryWithThisButton.colorIds = queryWithThisButton.colorIds.concat([colorId]);

  // Get queries with this button color added
  let queriesWithThisButton = [...queries];
  queriesWithThisButton = queriesWithThisButton.filter(
    q => q.reagentId !== query.reagentId
  );
  queriesWithThisButton.push(queryWithThisButton);

  //console.log("colorId = ", colorId, "reagentId = ", query.reagentId);
  const anyReactions = anyReactionsFromQueriesForReagent(
    queriesWithThisButton,
    isSimpleQuery,
    currentSubstanceIds,
    query.reagentId
  );
  //console.log("hasAnyReactions = ", anyReactions)

  // Not disabled if has any reactions
  return !anyReactions;
}